/**
 * byteArrayToBase64
 *  - 서버에서 전달된 signImage 값을 안전하게 Base64 PNG URL로 변환
 *  - Base64 문자열 / 정수 배열 모두 지원
 *  - 잘못된 값일 경우 null 반환
 *
 * @param {string | number[] | null} raw - 서버 signImage 원본
 * @returns {string | null} data:image/png;base64, 형태의 URL
 */
// export default function safeToBase64Image(byteArray) {
//   const uint8Array = new Uint8Array(byteArray); // 정수 배열 → Uint8Array 변환
//   let binaryString = '';
//
//   // Uint8Array 각 요소를 문자로 변환하여 binary string 구성
//   for (let i = 0; i < uint8Array.length; i++) {
//     binaryString += String.fromCharCode(uint8Array[i]);
//   }
//
//   // binary string → Base64
//   return window.btoa(binaryString);
// }
export default function safeToBase64Image(raw) {
  if (!raw) return null;

  // Case 1: 이미 Base64 문자열인 경우
  if (typeof raw === 'string') {
    return `data:image/png;base64,${raw}`;
  }

  // Case 2: 숫자 배열인 경우 → Base64로 변환
  if (Array.isArray(raw)) {
    const uint8 = new Uint8Array(raw);
    let binary = '';

    for (let i = 0; i < uint8.length; i++) {
      binary += String.fromCharCode(uint8[i]);
    }

    const base64 = window.btoa(binary);
    return `data:image/png;base64,${base64}`;
  }

  // Case 3: 예측 불가 타입 → 안전하게 null 반환
  console.warn('safeToBase64Image(): Unknown signImage type:', raw);
  return null;
}
